<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xvii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td>ASV</td>
<td>American Standard Version</td>
</tr>
<tr>
<td><span class="small">BCE</span></td>
<td>before Common Era</td>
</tr>
<tr>
<td>CEB</td>
<td>Common English Bible</td>
</tr>
<tr>
<td>CEV</td>
<td>Common English Version</td>
</tr>
<tr>
<td>cf.</td>
<td><i>confer</i>, compare</td>
</tr>
<tr>
<td>ch.</td>
<td>chapter</td>
</tr>
<tr>
<td>chs.</td>
<td>chapters</td>
</tr>
<tr>
<td>e.g.</td>
<td><i>exempli gratia</i>, for example</td>
</tr>
<tr>
<td>ERV</td>
<td>Easy-to-Read Version</td>
</tr>
<tr>
<td>ESV</td>
<td>English Standard Version</td>
</tr>
<tr>
<td>etc.</td>
<td><i>et cetera,</i> and so forth, and the rest</td>
</tr>
<tr>
<td>HCSB</td>
<td>Holman Christian Standard Bible</td>
</tr>
<tr>
<td>KJV</td>
<td>King James Version</td>
</tr>
<tr>
<td>lit.</td>
<td>literally</td>
</tr>
<tr>
<td>MEV</td>
<td>Modern English Version</td>
</tr>
<tr>
<td>NASB</td>
<td>New American Standard Bible</td>
</tr>
<tr>
<td>NCV</td>
<td>New Century Version</td>
</tr>
<tr>
<td>NIV</td>
<td>New International Version</td>
</tr>
<tr>
<td>NJPS</td>
<td>New Jewish Publication Society Translation</td>
</tr>
<tr>
<td>NLT</td>
<td>New Living Translation</td>
</tr>
<tr>
<td>NRSV</td>
<td>New Revised Standard Version</td>
</tr>
<tr>
<td>RSV</td>
<td>Revised Standard Version</td>
</tr>
<tr>
<td>v.</td>
<td>verse</td>
</tr>
<tr>
<td>vv.</td>
<td>verses</td>
</tr>
</tbody></table>
<p class="H1b"><span class="small">THE BOOKS OF THE OLD TESTAMENT</span></p>
<table cellpadding="0" cellspacing="0" class="Table2">
<tbody><tr>
<td class="tdleft"><a id="page_xviii">Genesis</a></td>
<td class="tdleft1">Gen.</td>
</tr>
<tr>
<td class="tdleft">Exodus</td>
<td class="tdleft1">Exod.</td>
</tr>
<tr>
<td class="tdleft">Leviticus</td>
<td class="tdleft1">Lev.</td>
</tr>
<tr>
<td class="tdleft">Numbers</td>
<td class="tdleft1">Num.</td>
</tr>
<tr>
<td class="tdleft">Deuteronomy</td>
<td class="tdleft1">Deut.</td>
</tr>
<tr>
<td class="tdleft">Joshua</td>
<td class="tdleft1">Josh.</td>
</tr>
<tr>
<td class="tdleft">Judges</td>
<td class="tdleft1">Judg.</td>
</tr>
<tr>
<td class="tdleft">Ruth</td>
<td class="tdleft1">Ruth</td>
</tr>
<tr>
<td class="tdleft">1–2 Samuel</td>
<td class="tdleft1">1–2 Sam.</td>
</tr>
<tr>
<td class="tdleft">1–2 Kings</td>
<td class="tdleft1">1–2 Kgs.</td>
</tr>
<tr>
<td class="tdleft">1–2 Chronicles</td>
<td class="tdleft1">1–2 Chr.</td>
</tr>
<tr>
<td class="tdleft">Ezra</td>
<td class="tdleft1">Ezra</td>
</tr>
<tr>
<td class="tdleft">Nehemiah</td>
<td class="tdleft1">Neh.</td>
</tr>
<tr>
<td class="tdleft">Esther</td>
<td class="tdleft1">Esther</td>
</tr>
<tr>
<td class="tdleft">Job</td>
<td class="tdleft1">Job</td>
</tr>
<tr>
<td class="tdleft">Psalms</td>
<td class="tdleft1">Ps. (plural Pss.)</td>
</tr>
<tr>
<td class="tdleft">Proverbs</td>
<td class="tdleft1">Prov.</td>
</tr>
<tr>
<td class="tdleft">Ecclesiastes</td>
<td class="tdleft1">Eccl.</td>
</tr>
<tr>
<td class="tdleft">Song of Songs</td>
<td class="tdleft1">Song</td>
</tr>
<tr>
<td class="tdleft">Isaiah</td>
<td class="tdleft1">Isa.</td>
</tr>
<tr>
<td class="tdleft">Jeremiah</td>
<td class="tdleft1">Jer.</td>
</tr>
<tr>
<td class="tdleft">Lamentations</td>
<td class="tdleft1">Lam.</td>
</tr>
<tr>
<td class="tdleft">Ezekiel</td>
<td class="tdleft1">Ezek.</td>
</tr>
<tr>
<td class="tdleft">Daniel</td>
<td class="tdleft1">Dan.</td>
</tr>
<tr>
<td class="tdleft">Hosea</td>
<td class="tdleft1">Hosea</td>
</tr>
<tr>
<td class="tdleft">Joel</td>
<td class="tdleft1">Joel</td>
</tr>
<tr>
<td class="tdleft">Amos</td>
<td class="tdleft1">Amos</td>
</tr>
<tr>
<td class="tdleft">Obadiah</td>
<td class="tdleft1">Obad.</td>
</tr>
<tr>
<td class="tdleft">Jonah</td>
<td class="tdleft1">Jonah</td>
</tr>
<tr>
<td class="tdleft">Micah</td>
<td class="tdleft1">Mic.</td>
</tr>
<tr>
<td class="tdleft">Nahum</td>
<td class="tdleft1">Nah.</td>
</tr>
<tr>
<td class="tdleft">Habakkuk</td>
<td class="tdleft1">Hab.</td>
</tr>
<tr>
<td class="tdleft">Zephaniah</td>
<td class="tdleft1">Zeph.</td>
</tr>
<tr>
<td class="tdleft">Haggai</td>
<td class="tdleft1">Hag.</td>
</tr>
<tr>
<td class="tdleft">Zechariah</td>
<td class="tdleft1">Zech.</td>
</tr>
<tr>
<td class="tdleft">Malachi</td>
<td class="tdleft1">Mal.</td>
</tr>
</tbody></table>
<p class="H1b"><span class="small">THE BOOKS OF THE NEW TESTAMENT</span></p>
<table cellpadding="0" cellspacing="0" class="Table2">
<tbody><tr>
<td class="tdleft">Matthew</td>
<td class="tdleft1">Matt.</td>
</tr>
<tr>
<td class="tdleft">Mark</td>
<td class="tdleft1">Mark</td>
</tr>
<tr>
<td class="tdleft">Luke</td>
<td class="tdleft1">Luke</td>
</tr>
<tr>
<td class="tdleft">John</td>
<td class="tdleft1">John</td>
</tr>
<tr>
<td class="tdleft">Acts</td>
<td class="tdleft1">Acts</td>
</tr>
<tr>
<td class="tdleft">Romans</td>
<td class="tdleft1">Rom.</td>
</tr>
<tr>
<td class="tdleft">1–2 Corinthians</td>
<td class="tdleft1">1–2 Cor.</td>
</tr>
<tr>
<td class="tdleft">Galatians</td>
<td class="tdleft1">Gal.</td>
</tr>
<tr>
<td class="tdleft">Ephesians</td>
<td class="tdleft1">Eph.</td>
</tr>
<tr>
<td class="tdleft">Philippians</td>
<td class="tdleft1">Phil.</td>
</tr>
<tr>
<td class="tdleft">Colossians</td>
<td class="tdleft1">Col.</td>
</tr>
<tr>
<td class="tdleft">1–2 Thessalonians</td>
<td class="tdleft1">1–2 Thess.</td>
</tr>
<tr>
<td class="tdleft">1–2 Timothy</td>
<td class="tdleft1">1–2 Tim.</td>
</tr>
<tr>
<td class="tdleft">Titus</td>
<td class="tdleft1">Titus</td>
</tr>
<tr>
<td class="tdleft">Philemon</td>
<td class="tdleft1">Phlm.</td>
</tr>
<tr>
<td class="tdleft">Hebrews</td>
<td class="tdleft1">Heb.</td>
</tr>
<tr>
<td class="tdleft">James</td>
<td class="tdleft1">Jas.</td>
</tr>
<tr>
<td class="tdleft">1–2 Peter</td>
<td class="tdleft1">1–2 Pet.</td>
</tr>
<tr>
<td class="tdleft">1, 2, 3 John</td>
<td class="tdleft1">1, 2, 3 John</td>
</tr>
<tr>
<td class="tdleft">Jude</td>
<td class="tdleft1">Jude</td>
</tr>
<tr>
<td class="tdleft">Revelation</td>
<td class="tdleft1">Rev.</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?2d40bb5e